/* global BigInt */
import React from 'react';
import { useServiceFeePolicy } from '../hooks/useServiceFeePolicy';
import { DEFAULT_SERVICE_FEE, calculateServiceFee, decimalToAtomic, formatUnits } from '../utils/serviceFees';
export default function ServiceFeeNotice({ kind, currency = 'SOL', amount = '', decimals = 9, isNative = true, quote = null }) {
    const { policy, loading, error } = useServiceFeePolicy();
    if (loading) return <p className="cc-hint">Loading service fee...</p>;
    if (error) return <p role="alert">{error}</p>;
    const rule = policy[kind + 'Fee'] || DEFAULT_SERVICE_FEE;
    const precision = quote?.decimals ?? decimals;
    let preview = kind === 'studioMint' && quote?.version === (policy.version || 0) ? quote : null;
    try { if (!preview && amount !== '' && precision != null) preview = calculateServiceFee(rule, decimalToAtomic(amount, precision), isNative); }
    catch { /* An incomplete amount is normal while editing. */ }
    return <div className="cc-hint" style={{ margin: '8px 0' }}>
        {!rule.enabled ? 'No service fee.' : <>
            Service fee: {rule.mode === 'percentage' ? (rule.basisPoints / 100) + '%' : formatUnits(rule.fixedLamports) + ' SOL'}.
            {kind === 'studioMint' ? rule.mode === 'percentage' ? ' Based on estimated Solana network cost and account rent, excluding uploads.' : ' Added to network and upload costs.' : ' Added on top; the recipient keeps the stated amount.'}
            {rule.mode === 'percentage' && kind !== 'studioMint' ? ' Charged in ' + currency + '.' : ''}
        </>}
        {preview && (kind === 'studioMint' ? <div>Service fee for this mint: {formatUnits(preview.solFeeLamports)} SOL.</div> :
            <div>Total before network and token-provider fees: {formatUnits(preview.totalPaymentAtomic, precision)} {currency}
                {!isNative && BigInt(preview.solFeeLamports) > 0n ? ' + ' + formatUnits(preview.solFeeLamports) + ' SOL' : ''}
            </div>)}
    </div>;
}
